import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from '../components';
import DragAndDrop from '../components/Form/DragAndDrop';
import { PageTitle } from '../components/Text';
import TwoRows from '../components/Structure/TwoRows';
import ActionButton from '../components/Button/Action';
import { Button } from '../components/Button';
import useFileUploadAction from '../hooks/useFileUploadAction';
import { Row } from '../components/Structure';
import './FileUploadScreen.scss';

const FileUploadScreen = () => {
  const [formData, setFormData] = useState(new FormData());
  const [disableButton, setDisableButton] = useState(true);
  const history = useHistory();
  const uploadFiles = useFileUploadAction();

  const onFileChange = (files, isValid) => {
    const newFormData = new FormData();
    setDisableButton(!isValid);
    Array.from(files).forEach((file, index) => {
      newFormData.append(`evidence_files[${index}]`, file, file.name);
    });
    setFormData(newFormData);
  };

  const handleSubmit = async () => {
    await uploadFiles(formData);
    setDisableButton(true);
  };

  return (
    <Page id="main">
      <div className="primary-content">
        <PageTitle>Attach Supporting Information</PageTitle>
        <p>
          Only attach relevant supporting documents, such as completed
          Competence Assessment Forms for A61/A62/A68. A logbook is not
          required unless we ask for it. We will contact the applicant if
          additional evidence is needed.
        </p>
      </div>
      <Row>
        <DragAndDrop onFileChange={onFileChange} />
      </Row>
      <TwoRows className="nav-buttons">
        <Button classButton="back" onPress={history.goBack}>
          Back
        </Button>
        <ActionButton
          processing={disableButton}
          classButton="send-form"
          type="submit"
          onPress={handleSubmit}
        >
          Submit
        </ActionButton>
      </TwoRows>
    </Page>
  );
};

export default FileUploadScreen;
